// Campus photo for /colleges/george-mason-university: CC BY 4.0, by Wehwalt, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AGeorge_Mason_campus_and_statue.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/george-mason-university/; credited under the photo.
const photo = {
    "slug": "george-mason-university",
    "alt": "The bronze George Mason statue beside a tree-lined walkway on the Fairfax campus in autumn",
    "src": "/colleges/george-mason-university/campus-1600.webp",
    "srcSmall": "/colleges/george-mason-university/campus-800.webp",
    "srcMid": "/colleges/george-mason-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/george-mason-university/og.jpg",
    "title": "George Mason campus and statue",
    "author": "Wehwalt",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AGeorge_Mason_campus_and_statue.jpg",
    "read": "2026-10-01"
};

export default photo;
